import _regeneratorRuntime from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/VUE\u5EB7\u4E50\u901A\u95E8\u5E97/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["onUpdate:modelValue", "onConfirm", "onKeyup"];
var _hoisted_4 = ["onUpdate:modelValue"];
var _hoisted_5 = ["onClick"];
var _hoisted_6 = ["onClick"];
import TUIChatEngine, { TUIStore, StoreName, TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, computed } from "../../../adapter-vue";
import { isPC } from "../../../utils/env";
import { TUIGlobal } from "../../../utils/universal-api/index";
import { generateAvatar, generateContactInfoName, generateContactInfoBasic, isFriend, isApplicationType } from "../utils/index";
import { contactMoreInfoConfig, contactButtonConfig } from "./contact-info-config";
import Icon from "../../common/Icon.vue";
import editSVG from "../../../assets/icon/edit.svg";
import backSVG from "../../../assets/icon/back.svg";
import SwitchBar from "../../common/SwitchBar/index.vue";
import { CONTACT_INFO_LABEL_POSITION, CONTACT_INFO_MORE_EDIT_TYPE, CONTACT_INFO_BUTTON_TYPE } from "../../../constant";
import { deepCopy } from "../../TUIChat/utils/utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["switchConversation"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var contactInfoData = ref({});
    var contactInfoBasicList = ref([]);
    var contactInfoMoreList = ref([]);
    var contactInfoButtonList = ref([]);
    var showContactInfo = computed(function () {
      for (var i in contactInfoData.value) {
        return true;
      }
      return false;
    });
    var setEditing = function setEditing(item) {
      item.editing = true;
    };
    // 是否为群组类型
    var isGroup = computed(function () {
      var _contactInfoData$valu;
      return contactInfoData !== null && contactInfoData !== void 0 && (_contactInfoData$valu = contactInfoData.value) !== null && _contactInfoData$valu !== void 0 && _contactInfoData$valu.groupID ? true : false;
    });
    // 是否为申请类型
    var isApplication = computed(function () {
      return isApplicationType(contactInfoData === null || contactInfoData === void 0 ? void 0 : contactInfoData.value);
    });
    // 是否为双向好友关系, 若为群组类型则一直保持false
    var isBothFriend = ref(false);
    // 是否是群成员（包含普通成员、管理员、群主）
    var isGroupMember = computed(function () {
      var _contactInfoData$valu2;
      return contactInfoData !== null && contactInfoData !== void 0 && (_contactInfoData$valu2 = contactInfoData.value) !== null && _contactInfoData$valu2 !== void 0 && (_contactInfoData$valu2 = _contactInfoData$valu2.selfInfo) !== null && _contactInfoData$valu2 !== void 0 && _contactInfoData$valu2.userID ? true : false;
    });
    // 是否是黑名单用户, 若为群组类型则一直保持false
    var isInBlackList = computed(function () {
      var _blackList$value;
      return !isGroup.value && ((_blackList$value = blackList.value) === null || _blackList$value === void 0 ? void 0 : _blackList$value.findIndex(function (item) {
        var _contactInfoData$valu3;
        return (item === null || item === void 0 ? void 0 : item.userID) === (contactInfoData === null || contactInfoData === void 0 || (_contactInfoData$valu3 = contactInfoData.value) === null || _contactInfoData$valu3 === void 0 ? void 0 : _contactInfoData$valu3.userID);
      })) >= 0;
    });
    var blackList = ref([]);
    var resetContactInfoUIData = function resetContactInfoUIData() {
      contactInfoData.value = {};
      contactInfoBasicList.value = [];
      contactInfoMoreList.value = [];
      contactInfoButtonList.value = [];
    };
    var resetContactSearchingUIData = function resetContactSearchingUIData() {
      TUIStore.update(StoreName.CUSTOM, "currentContactInfo", {});
      TUIStore.update(StoreName.CUSTOM, "currentContactSearchingStatus", false);
      (TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.closeSearching) && (TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.closeSearching());
    };
    TUIStore.watch(StoreName.USER, {
      userBlacklist: function userBlacklist(_userBlacklist) {
        blackList.value = _userBlacklist;
      }
    });
    var onContactInfoEmitSubmit = function onContactInfoEmitSubmit(item) {
      item.editSubmitHandler && item.editSubmitHandler({
        item: item,
        contactInfoData: contactInfoData.value,
        isBothFriend: isBothFriend.value,
        isInBlackList: isInBlackList.value
      });
    };
    var onContactInfoButtonClicked = function onContactInfoButtonClicked(item) {
      item.onClick && item.onClick({
        contactInfoData: contactInfoData.value,
        contactInfoMoreList: contactInfoMoreList.value
      });
      if (item.key === "enterGroupConversation" || item.key === "enterC2CConversation") {
        emits("switchConversation", contactInfoData.value);
        // 清空当前 contact 相关数据信息
        resetContactSearchingUIData();
      }
    };
    var generateMoreInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _contactInfoData$valu4, _TUIChatEngine$TYPES, _contactInfoData$valu5, _contactInfoData$valu6;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 非 好友申请类 信息展示
              if (!isApplication.value) {
                // 非好友关系 / 非群成员 且 不在黑名单中 且 不是直播群，展示 申请加群/加好友验证信息 填写
                if (!isGroup.value && !isBothFriend.value && !isInBlackList.value || isGroup.value && !isGroupMember.value && (contactInfoData === null || contactInfoData === void 0 || (_contactInfoData$valu4 = contactInfoData.value) === null || _contactInfoData$valu4 === void 0 ? void 0 : _contactInfoData$valu4.type) !== (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES === void 0 ? void 0 : _TUIChatEngine$TYPES.GRP_AVCHATROOM)) {
                  contactMoreInfoConfig.setWords.data = "";
                  contactInfoMoreList.value.push(contactMoreInfoConfig.setWords);
                }
                // 用户界面，展示 备注名 设置，包含：
                // 1. 若为好友关系，直接修改好友相关资料
                // 2. 若非好友关系，且非黑名单用户，提供 申请加好友备注信息 填写
                if (!isGroup.value && !isInBlackList.value) {
                  contactMoreInfoConfig.setRemark.data = (contactInfoData === null || contactInfoData === void 0 || (_contactInfoData$valu5 = contactInfoData.value) === null || _contactInfoData$valu5 === void 0 ? void 0 : _contactInfoData$valu5.remark) || "";
                  contactMoreInfoConfig.setRemark.editing = false;
                  contactInfoMoreList.value.push(contactMoreInfoConfig.setRemark);
                }
                // 用户界面，展示 黑名单 设置，包含：
                // 1. 若为好友关系，提供设置黑名单入口
                // 2. 若已在黑名单中，提供接触黑名单入口
                if (!isGroup.value && (isBothFriend.value || isInBlackList.value)) {
                  contactMoreInfoConfig.blackList.data = isInBlackList.value || false;
                  contactInfoMoreList.value.push(contactMoreInfoConfig.blackList);
                }
              } else {
                // 对方 好友请求/群聊申请
                contactMoreInfoConfig.displayWords.data = (contactInfoData === null || contactInfoData === void 0 || (_contactInfoData$valu6 = contactInfoData.value) === null || _contactInfoData$valu6 === void 0 ? void 0 : _contactInfoData$valu6.wording) || "";
                contactInfoMoreList.value.push(contactMoreInfoConfig.displayWords);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function generateMoreInfo() {
        return _ref2.apply(this, arguments);
      };
    }();
    var generateButton = function generateButton() {
      var _contactInfoButtonLis3, _contactInfoButtonLis4;
      // 黑名单用户，在解除黑名单前没有任何操作button
      if (isInBlackList.value) {
        return;
      }
      // 非黑名单用户
      if (isApplication.value) {
        var _contactInfoData$valu7, _TUIChatEngine$TYPES2;
        if ((contactInfoData === null || contactInfoData === void 0 || (_contactInfoData$valu7 = contactInfoData.value) === null || _contactInfoData$valu7 === void 0 ? void 0 : _contactInfoData$valu7.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES2 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES2 === void 0 ? void 0 : _TUIChatEngine$TYPES2.SNS_APPLICATION_SENT_TO_ME)) {
          var _contactInfoButtonLis, _contactInfoButtonLis2;
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis = contactInfoButtonList.value) === null || _contactInfoButtonLis === void 0 || _contactInfoButtonLis.push(contactButtonConfig.refuseFriendApplication);
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis2 = contactInfoButtonList.value) === null || _contactInfoButtonLis2 === void 0 || _contactInfoButtonLis2.push(contactButtonConfig.acceptFriendApplication);
        }
      } else {
        if (isGroup.value && isGroupMember.value) {
          var _contactInfoData$valu8, _contactInfoButtonLis5;
          // 群聊信息页+是群成员
          switch (contactInfoData === null || contactInfoData === void 0 || (_contactInfoData$valu8 = contactInfoData.value) === null || _contactInfoData$valu8 === void 0 || (_contactInfoData$valu8 = _contactInfoData$valu8.selfInfo) === null || _contactInfoData$valu8 === void 0 ? void 0 : _contactInfoData$valu8.role) {
            case "Owner":
              contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis3 = contactInfoButtonList.value) === null || _contactInfoButtonLis3 === void 0 || _contactInfoButtonLis3.push(contactButtonConfig.dismissGroup);
              break;
            default:
              contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis4 = contactInfoButtonList.value) === null || _contactInfoButtonLis4 === void 0 || _contactInfoButtonLis4.push(contactButtonConfig.quitGroup);
              break;
          }
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis5 = contactInfoButtonList.value) === null || _contactInfoButtonLis5 === void 0 || _contactInfoButtonLis5.push(contactButtonConfig.enterGroupConversation);
        } else if (!isGroup.value && isBothFriend.value) {
          var _contactInfoButtonLis6, _contactInfoButtonLis7;
          // 用户信息页+是好友关系
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis6 = contactInfoButtonList.value) === null || _contactInfoButtonLis6 === void 0 || _contactInfoButtonLis6.push(contactButtonConfig.deleteFriend);
          contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis7 = contactInfoButtonList.value) === null || _contactInfoButtonLis7 === void 0 || _contactInfoButtonLis7.push(contactButtonConfig.enterC2CConversation);
        } else {
          // 群聊信息页+不是群成员 / 用户信息页 + 非好友关系
          if (isGroup.value) {
            var _contactInfoButtonLis8, _contactInfoData$valu9, _TUIChatEngine$TYPES3;
            contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis8 = contactInfoButtonList.value) === null || _contactInfoButtonLis8 === void 0 || _contactInfoButtonLis8.push((contactInfoData === null || contactInfoData === void 0 || (_contactInfoData$valu9 = contactInfoData.value) === null || _contactInfoData$valu9 === void 0 ? void 0 : _contactInfoData$valu9.type) === (TUIChatEngine === null || TUIChatEngine === void 0 || (_TUIChatEngine$TYPES3 = TUIChatEngine.TYPES) === null || _TUIChatEngine$TYPES3 === void 0 ? void 0 : _TUIChatEngine$TYPES3.GRP_AVCHATROOM) ? contactButtonConfig.joinAVChatGroup : contactButtonConfig.joinGroup);
          } else {
            var _contactInfoButtonLis9;
            contactInfoButtonList === null || contactInfoButtonList === void 0 || (_contactInfoButtonLis9 = contactInfoButtonList.value) === null || _contactInfoButtonLis9 === void 0 || _contactInfoButtonLis9.push(contactButtonConfig.addFriend);
          }
        }
      }
    };
    // 总: 当前联系人信息页数据源获取
    TUIStore.watch(StoreName.CUSTOM, {
      currentContactInfo: function () {
        var _currentContactInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
          var _Object$keys;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!(contactInfoData.value && data && JSON.stringify(contactInfoData.value) === JSON.stringify(data))) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                resetContactInfoUIData();
                // deep clone
                contactInfoData.value = deepCopy(data) || {};
                if (!(((_Object$keys = Object.keys(contactInfoData.value)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0)) {
                  _context2.next = 6;
                  break;
                }
                return _context2.abrupt("return");
              case 6:
                contactInfoBasicList.value = generateContactInfoBasic(contactInfoData.value);
                _context2.next = 9;
                return isFriend(contactInfoData.value);
              case 9:
                isBothFriend.value = _context2.sent;
                generateMoreInfo();
                generateButton();
                if (data.infoKeyList) {
                  contactInfoMoreList.value = data.infoKeyList.map(function (key) {
                    return contactMoreInfoConfig[key];
                  });
                }
                if (data.btnKeyList) {
                  contactInfoButtonList.value = data.btnKeyList.map(function (key) {
                    return contactButtonConfig[key];
                  });
                }
              case 14:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function currentContactInfo(_x) {
          return _currentContactInfo.apply(this, arguments);
        }
        return currentContactInfo;
      }()
    });
    return function (_ctx, _cache) {
      return _unref(showContactInfo) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(['TUI-contact-info', !_unref(isPC) && 'TUI-contact-info-h5'])
      }, [!_unref(isPC) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": _normalizeClass(['TUI-contact-info-header', !_unref(isPC) && 'TUI-contact-info-h5-header'])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['TUI-contact-info-header-icon', !_unref(isPC) && 'TUI-contact-info-h5-header-icon']),
        onClick: resetContactSearchingUIData
      }, [_createVNode(Icon, {
        file: _unref(backSVG)
      }, null, 8, ["file"])], 2), _createElementVNode("div", {
        "class": _normalizeClass(['TUI-contact-info-header-title', !_unref(isPC) && 'TUI-contact-info-h5-header-title'])
      }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.添加好友/群聊")), 3)], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        "class": _normalizeClass(['TUI-contact-info-basic', !_unref(isPC) && 'TUI-contact-info-h5-basic'])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['TUI-contact-info-basic-text', !_unref(isPC) && 'TUI-contact-info-h5-basic-text'])
      }, [_createElementVNode("div", {
        "class": _normalizeClass(['TUI-contact-info-basic-text-name', !_unref(isPC) && 'TUI-contact-info-h5-basic-text-name'])
      }, _toDisplayString(_unref(generateContactInfoName)(_unref(contactInfoData))), 3), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactInfoBasicList), function (item) {
        return _openBlock(), _createElementBlock("div", {
          "class": _normalizeClass(['TUI-contact-info-basic-text-other', !_unref(isPC) && 'TUI-contact-info-h5-basic-text-other']),
          key: item.label
        }, _toDisplayString("".concat(_unref(TUITranslateService).t("TUIContact.".concat(item.label)), ": \n            ").concat(item.data)), 3);
      }), 128))], 2), _createElementVNode("img", {
        "class": _normalizeClass(['TUI-contact-info-basic-avatar', !_unref(isPC) && 'TUI-contact-info-h5-basic-avatar']),
        src: _unref(generateAvatar)(_unref(contactInfoData))
      }, null, 10, _hoisted_1)], 2), _unref(contactInfoMoreList)[0] ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(['TUI-contact-info-more', !_unref(isPC) && 'TUI-contact-info-h5-more'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactInfoMoreList), function (item) {
        return _openBlock(), _createElementBlock("div", {
          "class": _normalizeClass(['TUI-contact-info-more-item', !_unref(isPC) && 'TUI-contact-info-h5-more-item', item.labelPosition === _unref(CONTACT_INFO_LABEL_POSITION).TOP ? 'TUI-contact-info-more-item-top' : 'TUI-contact-info-more-item-left']),
          key: item.key
        }, [_createElementVNode("div", {
          "class": _normalizeClass(['TUI-contact-info-more-item-label', !_unref(isPC) && 'TUI-contact-info-h5-more-item-label'])
        }, _toDisplayString("".concat(_unref(TUITranslateService).t("TUIContact.".concat(item.label)))), 3), _createElementVNode("div", {
          "class": _normalizeClass(['TUI-contact-info-more-item-content', !_unref(isPC) && 'TUI-contact-info-h5-more-item-content'])
        }, [!item.editing ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          "class": _normalizeClass(['TUI-contact-info-more-item-content-text', !_unref(isPC) && 'TUI-contact-info-h5-more-item-content-text'])
        }, [_createElementVNode("div", {
          "class": _normalizeClass(['TUI-contact-info-more-item-content-text-data', !_unref(isPC) && 'TUI-contact-info-h5-more-item-content-text-data'])
        }, _toDisplayString(item.data), 3), item.editable ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: function onClick($event) {
            return setEditing(item);
          },
          "class": _normalizeClass(['TUI-contact-info-more-item-content-text-icon', !_unref(isPC) && 'TUI-contact-info-h5-more-item-content-text-icon'])
        }, [_createVNode(Icon, {
          file: _unref(editSVG),
          width: "14px",
          height: "14px"
        }, null, 8, ["file"])], 10, _hoisted_2)) : _createCommentVNode("", true)], 2)) : item.editType === _unref(CONTACT_INFO_MORE_EDIT_TYPE).INPUT ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          "class": _normalizeClass(['TUI-contact-info-more-item-content-input', !_unref(isPC) && 'TUI-contact-info-h5-more-item-content-input']),
          type: "text",
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.data = $event;
          },
          onConfirm: function onConfirm($event) {
            return onContactInfoEmitSubmit(item);
          },
          onKeyup: _withKeys(function ($event) {
            return onContactInfoEmitSubmit(item);
          }, ["enter"])
        }, null, 42, _hoisted_3)), [[_vModelText, item.data]]) : item.editType === _unref(CONTACT_INFO_MORE_EDIT_TYPE).TEXTAREA ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 2,
          "class": _normalizeClass(['TUI-contact-info-more-item-content-textarea', !_unref(isPC) && 'TUI-contact-info-h5-more-item-content-textarea']),
          "confirm-type": "done",
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return item.data = $event;
          }
        }, null, 10, _hoisted_4)), [[_vModelText, item.data]]) : item.editType === _unref(CONTACT_INFO_MORE_EDIT_TYPE).SWITCH ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          onClick: function onClick($event) {
            return onContactInfoEmitSubmit(item);
          }
        }, [_createVNode(SwitchBar, {
          value: item.data
        }, null, 8, ["value"])], 8, _hoisted_5)) : _createCommentVNode("", true)], 2)], 2);
      }), 128))], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        "class": _normalizeClass(['TUI-contact-info-button', !_unref(isPC) && 'TUI-contact-info-h5-button'])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactInfoButtonList), function (item) {
        return _openBlock(), _createElementBlock("button", {
          "class": _normalizeClass(['TUI-contact-info-button-item', !_unref(isPC) && 'TUI-contact-info-h5-button-item', item.type === _unref(CONTACT_INFO_BUTTON_TYPE).CANCEL ? "TUI-contact-info-button-item-cancel" : "TUI-contact-info-button-item-submit"]),
          key: item.key,
          onClick: function onClick($event) {
            return onContactInfoButtonClicked(item);
          }
        }, _toDisplayString(_unref(TUITranslateService).t("TUIContact.".concat(item.label))), 11, _hoisted_6);
      }), 128))], 2)], 2)) : _createCommentVNode("", true);
    };
  }
});